// addMeetingToTrip — pure builder that appends a meeting to the edited trip.
//
// Extracted verbatim from `EditTripModal.js` (the body of `handleAddMeeting`
// that computes `updatedMeetings = [...editedTrip.meetings, meeting]` and
// returns `{ ...prev, meetings: updatedMeetings }`) as part of the
// behavior-preserving refactor (issue #240). It immutably builds the next trip
// with the new meeting appended to the end of the existing `meetings` array.
//
// Totality preserved exactly: the source read `editedTrip.meetings` directly
// (it is guaranteed an array by `initializeEditedTrip`), so this builder does
// the same and adds no extra guard. The async wrapper and the `setShowAddMeeting`
// side effect stay in the hook/container.
//
// React-free and side-effect-free.
//
// Validates: Requirements 3.1, 3.4, 3.5, 1.6

/**
 * Returns the next edited trip with `meeting` appended to its meetings.
 *
 * @param {Object} editedTrip - The current edited-trip working copy.
 * @param {Object} meeting - The meeting to append.
 * @returns {Object} The next edited-trip object.
 */
export function addMeetingToTrip(editedTrip, meeting) {
  const updatedMeetings = [...editedTrip.meetings, meeting];
  return {
    ...editedTrip,
    meetings: updatedMeetings
  };
}

export default addMeetingToTrip;
